<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :rowSelection="computedSelect"
        :loading="loading"
        size="middle"
      >
        <template slot="student_code" slot-scope="student">
          <div>
            <div>
              <span class="text-wrap">{{student.student_code}}</span>
            </div>
          </div>
        </template>
        <template slot="student_name" slot-scope="student">
          <div>
            <div>
              <span class="text-wrap">{{student.first_name}} {{student.last_name}}</span>
            </div>
          </div>
        </template>
        <template slot="message" slot-scope="message">
          <div>
            <div>
              <span class="text-wrap">{{message}}</span>
            </div>
          </div>
        </template>
        <template slot="subject" slot-scope="subject">
          <div>
            <span class="text-wrap">{{subject}}</span>
          </div>
        </template>
<!--        <template slot="schoolclass" slot-scope="schoolclass">
          <div>
            <div class="font-weight-bold">{{schoolclass ? schoolclass.name : 'All'}}</div>
          </div>
        </template>
        <template slot="section" slot-scope="section">
          <div>
            <div class="font-weight-bold">{{section ? section.name : 'All'}}</div>
          </div>
        </template>-->
        <template slot="phone" slot-scope="phone">
          <div>
            <span class="text-wrap">{{phone}}</span>
          </div>
        </template>
        <template slot="status" slot-scope="status">
          <div>
            <div class="font-weight-bold">
              <a-tag
                :color="status === 'sent' ? 'blue' :
                status === 'delivered' ? 'green' :
                status === 'read' ? 'purple' :
                status === 'failed' ? 'volcano' :
                status === 'rejected' ? 'pink' : 'gold'">{{status.toUpperCase()}}</a-tag>
            </div>
          </div>
        </template>
<!--        <template slot="type" slot-scope="type">
          <div>
            <a-tag :color="type === 'notify' ? 'geekblue' : 'green'">{{type.toUpperCase()}}</a-tag>
          </div>
        </template>-->
<!--        <template slot="target" slot-scope="target">
          <div>
            <div class="font-weight-bold">
              <span class="text-wrap">
                <a-tag v-for="(targets, index) in getTargets(target)" :key="index">
                  {{targets.toUpperCase()}}
                </a-tag>
              </span>
            </div>
          </div>
        </template>-->
        <template slot="recipients" slot-scope="recipients">
          <div>
            <div>
              <p class="mb-0">App:
                <span class="font-weight-bold">{{recipients.push}}</span>
              </p>
              <p class="mb-0">SMS:
                <span class="font-weight-bold">{{recipients.sms}}</span>
              </p>
              <p class="mb-0">Email:
                <span class="font-weight-bold">{{recipients.email}}</span>
              </p>
            </div>
          </div>
        </template>
        <template slot="sent_on" slot-scope="sent_on">
          <div>
            <div>{{moment(sent_on).format('DD-MMM-YYYY hh:MM A')}}</div>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
const columns = [
  {
    title: 'Stud. Code',
    className: 'text-left text-gray-6',
    width: '100px',
    dataIndex: 'student',
    scopedSlots: { customRender: 'student_code' },
    sorter: (a, b) => a.student.localeCompare(b.student),
  },
  {
    title: 'Name',
    className: 'text-left text-gray-6',
    width: '200px',
    dataIndex: 'student',
    scopedSlots: { customRender: 'student_name' },
    sorter: (a, b) => a.student.localeCompare(b.student),
  },
  {
    title: 'Message',
    className: 'text-left text-gray-6 w-25',
    width: '300px',
    dataIndex: 'message',
    scopedSlots: { customRender: 'message' },
    sorter: (a, b) => a.message.localeCompare(b.message),
  },
  {
    title: 'Subject',
    className: 'text-left text-gray-6',
    width: '80px',
    dataIndex: 'subject',
    scopedSlots: { customRender: 'subject' },
    sorter: (a, b) => a.subject.localeCompare(b.subject),
  },
  /*  {
    title: 'Class',
    className: 'text-left text-gray-6',
    dataIndex: 'school_class',
    scopedSlots: { customRender: 'schoolclass' },
    sorter: (a, b) => a.class.localeCompare(b.class),
  },
  {
    title: 'Section',
    className: 'text-left text-gray-6',
    dataIndex: 'section',
    scopedSlots: { customRender: 'section' },
    sorter: (a, b) => a.section.localeCompare(b.section),
  }, */
  {
    title: 'Phone',
    className: 'text-center text-gray-6',
    width: '100px',
    dataIndex: 'phone',
    scopedSlots: { customRender: 'phone' },
    sorter: (a, b) => a.phone.localeCompare(b.phone),
  },
  {
    title: 'Status',
    className: 'text-center text-gray-6',
    width: '60px',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    sorter: (a, b) => a.status.localeCompare(b.status),
  },
  /* {
    title: 'Types',
    className: 'text-center text-gray-6',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
    sorter: (a, b) => a.type.localeCompare(b.type),
  }, */
  /* {
    title: 'Targets',
    className: 'text-center text-gray-6',
    // dataIndex: 'section',
    scopedSlots: { customRender: 'target' },
  }, */
  {
    title: 'Recipients',
    className: 'text-right text-gray-6',
    width: '100px',
    // dataIndex: 'recipients',
    scopedSlots: { customRender: 'recipients' },
  },
  {
    title: 'Sent on',
    className: 'text-right text-wrap text-gray-6',
    width: '100px',
    dataIndex: 'created_at',
    scopedSlots: { customRender: 'sent_on' },
    sorter: (a, b) => moment(a.created_at).unix() - moment(b.created_at).unix(),
  },
]

export default {

  name: 'ExamResultSendTable',
  components: {
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    /* getTargets(data) {
      let target = []
      if (data.student) {
        target.push('Student')
      }
      if (data.teacher) {
        target.push('Teacher')
      }
      return target
    }, */
  },
}
</script>
